import { render, staticRenderFns } from "./TradeFullFillmentWorkFlow.vue?vue&type=template&id=f2807256"
import script from "./TradeFullFillmentWorkFlow.vue?vue&type=script&lang=js"
export * from "./TradeFullFillmentWorkFlow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports